module.exports = __webpack_public_path__ + "img/html-evolution-11.0b287235.jpg";